export const VT_802_SPIRITS_DISTRIBUTOR_ID = 18600;

export const OHLQ_DISTRIBUTOR_ID = 16114;
